export default "__VITE_ASSET__B$YJQiLn__"